module.exports = __webpack_public_path__ + "static/media/hibernia.37238cc0.png";